import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_PROGRAM, type Program } from './types';

const initialState: Program | null = null;

export function programReducer(state = initialState, action: PayloadAction<Program | null>): Program | null {
	switch (action.type) {
		case SET_PROGRAM:
			return action.payload;
		default:
			return state;
	}
}
